import { Box } from '@mui/material';
import { clampLinesSx } from '@qb/frontend/utils/clampLinesSx';
type PostSummaryProps = {
  postSummaryHtml: string;
};
export const PostSummary = ({
  postSummaryHtml
}: PostSummaryProps) => <Box sx={{
  ...clampLinesSx(3),
  typography: 'bodyLarge',
  lineHeight: '150%',
  '& *': {
    my: 0
  }
}} dangerouslySetInnerHTML={{
  __html: postSummaryHtml
}} data-sentry-element="Box" data-sentry-component="PostSummary" data-sentry-source-file="PostSummary.tsx" />;